// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__jGlG6","author":"Table_author__3WixS","authorImage":"Table_authorImage__224Fx","unreadRow":"Table_unreadRow__GuD-7"};